// extracted by mini-css-extract-plugin
export var TitleContainer = "Title-module--TitleContainer--2zWyv";
export var GreenText = "Title-module--GreenText--3MSSX";